import BaseApiModule from './BaseApiModule'

class OfferApiModule extends BaseApiModule {
  readonly controller: string

  constructor(url: string) {
    super(url)
    this.controller = 'offer'
  }

  getOfferTemplateData(uuid: string): string {
    const methodUrl = "public"
    return `${this.baseUrl}/${this.controller}/${methodUrl}/${uuid}`
  }
}

export default OfferApiModule
